import $ from 'jquery';
import include_google_maps from '../libs/include_google_maps';
import anchor_link from '../libs/anchor_link';
import block_width from '../libs/block_width';

export default
{
    init() {
    },

    finalize() {
        // block_width(".nav-item");
        include_google_maps();
        anchor_link("#newsletter-section", "#newsletter");
    },

};



// WEBPACK FOOTER //
// ./scripts/routes/contatti.js